import { Controller } from '@hotwired/stimulus';
import axios from 'axios';

export default class extends Controller {
	static targets = ['form', 'pageField', 'perPageField', 'typeField', 'actionField', 'results', 'showMoreButton', 'filterButton'];

	itemsPerPage = 10;

	connect() {}

	filter(e) {
		this.actionFieldTarget.value = 'filter_news';
		this.typeFieldTarget.value = e.currentTarget.dataset.type;
		this.pageFieldTarget.value = 0;

		this.filterButtonTargets.forEach((button) => {
			button.classList.remove('active-filter-button');
		});

		e.currentTarget.classList.add('active-filter-button');

		this.getResults(e);
	}

	loadMore(e) {
		e.preventDefault();
		this.actionFieldTarget.value = 'load_more_news';
		this.pageFieldTarget.value = parseInt(this.pageFieldTarget.value, 10) + 1;
		this.getResults(e);
	}

	getResults(e) {
		e.preventDefault();

		const formData = new FormData(this.formTarget);
		this.formTarget.setAttribute('data-group-loading', 'true');

		axios
			.post(supersage.ajaxURL, formData)
			.then((response) => {
				if (response.data.html) {
					if (parseInt(this.pageFieldTarget.value, 10) === 0) {
						this.resultsTarget.innerHTML = '';
					}
					this.resultsTarget.insertAdjacentHTML('beforeend', response.data.html);

					const currentMax = (parseInt(this.pageFieldTarget.value, 10) + 1) * parseInt(this.perPageFieldTarget.value, 10);
					if (response.data.found < currentMax) {
						this.showMoreButtonTarget.classList.add('hidden');
					} else {
						this.showMoreButtonTarget.classList.remove('hidden');
					}
					this.formTarget.removeAttribute('data-group-loading');
				}
			})
			.catch((error) => {
				console.error('Error fetching results', error);
				this.formTarget.removeAttribute('data-group-loading');
			});
	}
}
